export const safeFileName = (title) =>
  `${title.replace(/[^\w\s.-]/g, "").trim().replace(/\s+/g, "_")}.pdf`;

export const isS3Link = (url) =>
  /(?:s3[.-]|\bamazonaws\.com\b)/i.test(url);

export const downloadViaFetch = async (url, filename) => {
  const res = await fetch(url, {
    method: "GET",
    mode: "cors",
    credentials: "omit",
  });
  if (!res.ok) throw new Error(`Fetch failed with status ${res.status}`);
  const blob = await res.blob();
  const objectUrl = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(objectUrl);
};

export const downloadViaIframe = (url) => {
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = url;
  document.body.appendChild(iframe);
  setTimeout(() => {
    try {
      document.body.removeChild(iframe);
    } catch (e) {}
  }, 60000);
};

export const navigateTo = (url) => {
  window.location.assign(url);
};
